module.exports = __webpack_public_path__ + "static/media/mask (3).ccec3bb0.png";